import type { RouteObject } from 'react-router-dom';

import { AppShellProviders } from '@/components/common/AppShellProviders';
import { AppLayout } from '@/components/layout/AppLayout';
import { ProtectedRoute } from '@/features/auth/ProtectedRoute';

import { AgentDetailPage } from './pages/AgentDetailPage';
import { AgentsListPage } from './pages/AgentsListPage';
import { TemplateGalleryPage } from './pages/TemplateGalleryPage';
import { AgentWizardPage } from './wizard/AgentWizardPage';

/**
 * Agents feature routes (design §5) — flat glob registry (`src/features/
 * registry.ts`), own `ProtectedRoute → AppShellProviders → AppLayout` tree
 * exactly like the projects feature re-declares the `/organizations/:orgId`
 * prefix: branches only match when fully consumable, so the orgs/projects/
 * agents trees never collide.
 *
 *   /organizations/:orgId/agents                     AgentsListPage
 *   /organizations/:orgId/agents/new                 TemplateGalleryPage
 *   /organizations/:orgId/agents/new/:templateId     AgentWizardPage (deep-linkable)
 *   /organizations/:orgId/agents/:agentId            AgentDetailPage
 *
 * Static `new` ranks above the `:agentId` param, so no ordering trick is
 * needed. No top-level `nav.ts`: agents are always reached through their
 * organization (same stance as the projects feature).
 */
export const routes: RouteObject[] = [
  {
    path: '/organizations/:orgId/agents',
    element: (
      <ProtectedRoute>
        <AppShellProviders>
          <AppLayout />
        </AppShellProviders>
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <AgentsListPage /> },
      { path: 'new', element: <TemplateGalleryPage /> },
      { path: 'new/:templateId', element: <AgentWizardPage /> },
      { path: ':agentId', element: <AgentDetailPage /> },
    ],
  },
];
